import { useTranslation } from 'react-i18next';

import { getCodedAnnotationPresentation } from 'services/webediErrors/annotationPresentation';
import { WebEDIEphemeralPartnerWarning } from 'services/webediErrors/types';
import { WithRef } from 'support/types/withRef';

import { ActionsSection } from '../../components/ActionsSection';
import { EditDocumentButton } from '../../components/EditDocumentButton/EditDocumentButton';
import { NavigationFooter } from '../../components/NavigationFooter';
import { FieldAnnotationPopoverShell } from '../../FieldAnnotationPopoverShell';

type Props = {
  annotation: WebEDIEphemeralPartnerWarning;
  viewMode: boolean;
  style?: React.CSSProperties;
};

export const EphemeralPartnerWarning = ({ annotation, viewMode, ref, style }: WithRef<Props, HTMLDivElement>) => {
  const { t } = useTranslation();
  const name = annotation.currentValue.name;
  const hasName = name.trim().length > 0;

  return (
    <FieldAnnotationPopoverShell
      ref={ref}
      style={style}
      status="warning"
      title={t(getCodedAnnotationPresentation(annotation).titleKey)}
      description={
        <span className="whitespace-pre-wrap">
          {hasName
            ? t('webedi:fieldAnnotation.ephemeralPartnerWarning.description', { name })
            : t('webedi:fieldAnnotation.ephemeralPartnerWarning.descriptionFallback')}
        </span>
      }
      actions={
        <ActionsSection>
          <EditDocumentButton viewMode={viewMode} annotation={annotation} />
        </ActionsSection>
      }
      footer={<NavigationFooter />}
    />
  );
};

/**
 * i18n keys
 * t('webedi:fieldAnnotation.ephemeralPartnerWarning.title')
 */
